import { create } from 'zustand';

interface AssistantNameState {
  availableAssistants: string[];
  selectedAssistant: string;
  isInitialized: boolean;
  setAvailableAssistants: (assistants: string[]) => void;
  setSelectedAssistant: (assistant: string) => void;
}

const assistantNameStore = create<AssistantNameState>((set, get) => ({
  availableAssistants: [],
  selectedAssistant: '',
  isInitialized: false,
  setAvailableAssistants: (assistants: string[]) => {
    const currentState = get();
    if (!currentState.isInitialized && assistants.length > 0) {
      set({
        availableAssistants: assistants,
        selectedAssistant: assistants[0],
        isInitialized: true,
      });
    } else if (currentState.isInitialized) {
      set({ availableAssistants: assistants });
    }
  },
  setSelectedAssistant: (assistant: string) => set({ selectedAssistant: assistant }),
}));

export default assistantNameStore;

